import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import moment from 'moment';
import _, { map } from 'underscore';
import { UserService } from '../../_Services/user.service';
import { pagination } from '../../_Models/pagination';
@Component({
    selector: 'mt-filters',
    templateUrl: 'filters.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersComponent implements OnInit, OnChanges {
  @Input() pageName?: string;
  @Input() uploadSheet: boolean = true;
  @Input() filterParams: any = {};
  @Output() onFilter = new EventEmitter<any>();

  pagelengths: any = pagination;
  showFilters: boolean = false;
  search: string = '';
  isAllFilter: boolean = false;

  // for all filters
  filtersArray: any = [];
  chipsObj: any = {};
  chipsList: any = [];
  showImport: boolean = false;
  showUploadBox: boolean = false;
  isLoading: boolean = false;

  // tslint:disable
  constructor(private filterService: UserService) {}

  ngOnInit() {
    this.getAllFilters();
  }

  ngOnChanges() {
    this.filterParams = Object.assign({}, this.filterParams);
    this.displayChips(JSON.stringify(this.filterParams));
  }

  // to show all applied filters
  showAppliedFilters() {
    this.isAllFilter = !this.isAllFilter;
  }

  // to get all the filters from the storage
  getAllFilters() {
    if (this.filtersArray.length <= 0) {
      let postObj = {};
      this.fetchRedisFilter(postObj);
    }
    this.displayChips(JSON.stringify(this.filterParams));
  }

  // on Apply filter
  onApplyFilter = async ($event: boolean) => {
    if ($event) {
      this.formatDate(this.filterParams, this.filtersArray);
      this.onChanges('filter', 'filter', this.filterParams);
    } else {
      this.filterParams = Object.assign({}, {});
      this.onChanges('clear', 'filter', this.filterParams);
    }
    this.displayChips(JSON.stringify(this.filterParams));
  };

  formatDate(appliedFilters: any, filtersArray: any) {
    filtersArray.forEach((filter: any) => {
      if (filter[this.pageName] && filter.type == 'date') {
        if (!_.isEmpty(appliedFilters[filter.model])) {
          appliedFilters[filter.model] = moment(
            appliedFilters[filter.model]
          ).format('YYYY-MM-DD');
        }
      }
    });
    return (this.filterParams = Object.assign({}, appliedFilters));
  }

  // on filter actions
  onChanges(type: string, model?: string, value?: any) {
    this.onFilter.emit({ type, model, value });
    this.openFilters(false);
  }

  // on open filter modal
  openFilters(flag: boolean) {
    this.showFilters = flag;
  }

  // on open import modal
  openImport(flag: boolean) {
    this.showImport = flag;
  }

  // new function for calling api
  fetchRedisFilter(postObj: any) {
    this.filterService.getRedisCache(postObj).subscribe((data) => {
      if (data && data.filters.length > 0) {
        this.filtersArray = data.filters;
        if (
          this.filterParams.crIndex &&
          this.filterParams[this.filterParams.crModel]
        ) {
          this.onChangeFilter(
            this.filterParams.crIndex - 1,
            this.filtersArray[this.filterParams.crIndex - 1].model
          );
        }
      }
    });
  }

  onSelectAll(event: any) {
    if (event && event.param !== undefined) {
      this.onChangeFilter(event.param, event.model);
    }
  }

  // on change the filter
  onChangeFilter(index: any, model: any, $event?: any) {
    if (index && model) {
      if (!this.filtersArray[index + 1].totalOptions) {
        this.filtersArray[index + 1].totalOptions =
          this.filtersArray[index + 1].options;
      }
      // this.filtersArray[index + 1].options = [];
      for (let i = 0; i < this.filterParams[model].length; i++) {
        let options = [];
        options = this.filtersArray[index + 1].totalOptions.filter((obj) => {
          return obj.type === this.filterParams[model][i];
        });
        this.filtersArray[index + 1].options = this.filtersArray[
          index + 1
        ].options.concat(this.filtersArray[index + 1].totalOptions);
      }
      this.filtersArray[index + 1].options.sort(function (a, b) {
        if (a.display.toLowerCase() < b.display.toLowerCase()) {
          return -1;
        }
        if (a.display.toLowerCase() > b.display.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      this.filterParams['crIndex'] = index + 1;
      this.filterParams['crModel'] = this.filtersArray[index + 1].model;
      this.filtersArray[index + 1][this.pageName] = true;
    }
  }
  // display chips
  displayChips(chipObj: any) {
    this.chipsList = [];
    this.chipsObj = JSON.parse(chipObj);
    for (const key in this.chipsObj) {
      if (key) {
        const optDetails = [];
        const filteredModel = this.filtersArray.find(
          (object) => object.model === key
        );
        if (
          this.chipsObj[key] &&
          (typeof this.chipsObj[key] === 'string' ||
            typeof this.chipsObj[key] === 'number')
        ) {
          if (filteredModel && filteredModel.options) {
            let resultObj = [];
            resultObj = filteredModel.options.find((object) => {
              if (filteredModel.value) {
                return this.chipsObj[key] === object[filteredModel.value];
              } else {
                return this.chipsObj[key] === object;
              }
            });
            optDetails.push(resultObj);
          } else if (filteredModel) {
            this.chipsList.push({
              name: filteredModel.name,
              display: undefined,
              value: this.chipsObj[key],
              model: filteredModel.model,
              type: filteredModel.type,
              nonRemovable: filteredModel.nonRemovable,
            });
          }
        } else if (
          this.chipsObj[key] &&
          this.chipsObj[key].constructor === Array
        ) {
          if (filteredModel && filteredModel.options) {
            for (let i = 0; i < this.chipsObj[key].length; i++) {
              let resultObj = [];
              resultObj = filteredModel.options.find((object) => {
                if (filteredModel.value) {
                  return this.chipsObj[key][i] === object[filteredModel.value];
                } else {
                  return this.chipsObj[key][i] === object;
                }
              });
              optDetails.push(resultObj);
            }
          }
        }
        for (let j = 0; j < optDetails.length; j++) {
          if (optDetails[j] && optDetails[j][filteredModel.value]) {
            this.chipsList.push({
              name: filteredModel.name,
              display: optDetails[j][filteredModel.display],
              value: optDetails[j][filteredModel.value],
              model: filteredModel.model,
              type: filteredModel.type,
              nonRemovable: filteredModel.nonRemovable,
            });
          } else {
            this.chipsList.push({
              name: filteredModel.name,
              display: optDetails[j][filteredModel.display],
              value: optDetails[j],
              model: filteredModel.model,
              type: filteredModel.type,
              nonRemovable: filteredModel.nonRemovable,
            });
          }
        }
      }
    }
  }
  // remove filter using chips
  removeAccountsFilter(obj: any) {
    if (this.filterParams[obj.model].constructor === Array) {
      const index = this.filterParams[obj.model].indexOf(obj.value);
      if (index > -1) {
        this.filterParams[obj.model].splice(index, 1);
      }
    } else {
      this.filterParams[obj.model] = undefined;
    }
    this.filterParams = Object.assign({}, this.filterParams);
    this.onChanges('filter', 'filter', this.filterParams);
  }

  openCloseUploadBox(event: any) {
    if (event && event.data && event.data['DuesList']) {
      this.filterParams = Object.assign({}, event.data);
      this.onChanges('upload', 'filter', this.filterParams);
      this.showImport = false;
    } else if (event && event.close) {
      this.showImport = false;
    }
  }
}
